import { useState } from 'react'
import { isApiError } from '../../api/client'
import { Button, Card, Field, textToneClass, type StatusTone } from '../../design'
import { GroundingList } from '../suggestion/GroundingList'
import { KB_COPY } from './copy'
import { useKbTest } from './queries'

const percentOf = (value: number): string => `${Math.round(Math.min(1, Math.max(0, value)) * 100)}%`

const KbGate = ({ topSimilarity, threshold }: { topSimilarity: number; threshold: number }) => (
  <>
    <div className="kb-gate" aria-hidden="true">
      <span className="kb-gate-fill" style={{ width: percentOf(topSimilarity) }} />
      <span className="kb-gate-tick" style={{ left: percentOf(threshold) }} />
    </div>
    <p className="kb-gate-legend">
      <span className="num kb-gate-score">{KB_COPY.topSimilarity(topSimilarity)}</span>
      <span className="num kb-gate-threshold">{KB_COPY.threshold(threshold)}</span>
    </p>
  </>
)

export const KbSandbox = () => {
  const [question, setQuestion] = useState('')
  const test = useKbTest()
  const result = test.data ?? null
  const tone: StatusTone = result !== null && result.answerable ? 'success' : 'warning'

  return (
    <Card as="section" className="kb-sandbox">
      <h2>{KB_COPY.sandboxTitle}</h2>
      <p className="kb-sandbox-hint">{KB_COPY.sandboxHint}</p>
      <div className="kb-ask">
        <Field id="kb-question" label={KB_COPY.question}>
          {({ id }) => <input id={id} value={question} onChange={(event) => setQuestion(event.target.value)} />}
        </Field>
        <Button
          variant="primary"
          disabled={question.trim() === ''}
          pending={test.isPending}
          pendingLabel={KB_COPY.testing}
          onClick={() => test.mutate(question.trim())}
        >
          {KB_COPY.test}
        </Button>
      </div>
      {isApiError(test.error) ? (
        <p className="tone-danger kb-sandbox-error" role="alert">
          {test.error.message}
        </p>
      ) : null}
      {result === null ? null : (
        <div className="kb-result">
          <div className={`kb-verdict ${textToneClass(tone)}`}>
            <p className="kb-verdict-title">{result.answerable ? KB_COPY.answerable : KB_COPY.notAnswerable}</p>
            <KbGate topSimilarity={result.topSimilarity} threshold={result.threshold} />
          </div>
          {result.sources.length === 0 ? null : (
            <div className="kb-result-sources">
              <GroundingList sources={result.sources} />
            </div>
          )}
        </div>
      )}
    </Card>
  )
}
